export default __webpack_public_path__ + "static/media/Pickpocket's Straps of the Stolen Kingdom.815b1748.jpg";